import * as commonFields from "./common-fields";
import type { GpitDto } from "@ckweb/ckfetch/connectables/taskListManagement";

export const globalTaskSchema: $ck.z.ZodType<GpitDto> = $ck.z.object({
  sequence: commonFields.optionalNumberField(),
  description: commonFields.requiredStringField(),
  descriptionBilingual: commonFields.stringOrEmptyField(),
  showCompleted: commonFields.booleanField(),
  showForEquipment: commonFields.booleanField(),
  showForNonEquipment: commonFields.booleanField(),
});

export type GlobalTaskSchema = $ck.z.TypeOf<typeof globalTaskSchema>;
